import { action, computed, observable } from 'mobx';

import { ViewController } from '@estee/elc-service';

import { IFieldsValidations, IFormSchema } from '~domain/entities/Config';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { TranslationRepository } from '~repositories/TranslationRepository';
import { composeFieldsValidations, FieldValidations } from '~utils/FieldValidations';

interface IDynamicFormViewController {
    configRepository: ConfigRepository;
    translationRepository: TranslationRepository;
}

export class DynamicFormViewController extends ViewController {
    private configRepository: ConfigRepository;
    private translationRepository: TranslationRepository;

    @observable public initialized: boolean = false;
    @observable public fieldsValidations: Record<string, FieldValidations> = {};

    constructor({ translationRepository, configRepository }: IDynamicFormViewController) {
        super();
        this.configRepository = configRepository;
        this.translationRepository = translationRepository;
    }

    @computed
    public get data() {
        const { translations } = this.translationRepository;
        const { readonlyFields, highlightedFields, removeHighlight } = this.configRepository;

        return {
            initialized: this.initialized,
            readonlyFields,
            highlightedFields,
            translations,
            fieldsValidations: this.fieldsValidations,
            removeHighlight
        };
    }

    @action
    loaded = async (formSchema: IFormSchema, validationObject?: IFieldsValidations) => {
        const { translations } = this.translationRepository;
        const { rampCommon: { badCharValidation } = {} } = this.configRepository;

        if (validationObject) {
            this.fieldsValidations = composeFieldsValidations(
                formSchema,
                validationObject,
                translations,
                badCharValidation
            );
        }

        this.initialized = true;
    };
}
